import { formatNumber, FormatNumberOptions } from 'utils/utilities'

type Data = {
  title: string
  subTitle?: string
  value: number | string | null | undefined
  valueFormat?: FormatNumberOptions
}

type DataCardProps = {
  heading: string
  data: Data[]
  fullWidth?: boolean
}

export const DataCard = (props: DataCardProps) => {
  const { heading, data, fullWidth } = props

  return (
    <div className={`w-full ${!fullWidth ? 'sm:w-auto sm:min-w-100' : ''}`}>
      <h1 className="bg-primary-dark text-white text-center text-lg rounded-t-md px-14 py-4">{heading}</h1>
      <div className="flex flex-wrap p-6 gap-8 bg-gray-100 rounded-b-md">
        {data.map((item, index) => (
          <div key={`${index}-${item.value}`} className="flex flex-1 flex-col items-center">
            <div className="h-40 w-40 flex items-center justify-center rounded-full text-white bg-primary-dark">
              {typeof item.value === 'number' ? (
                <span className="text-2xl">{formatNumber(item.value, item.valueFormat)}</span>
              ) : (
                <span className="text-xl">{item.value ?? 'No Data'}</span>
              )}
            </div>
            <div className="text-primary-dark text-center text-lg font-light mt-2">
              <span>{item.title}</span>
              {item.subTitle && <span>{item.subTitle}</span>}
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
